import * as angular from 'angular';

import { ComponentDefinition, IApiInformation } from '../../../models';
import { ILicenseService, ILoggerService, IQuerySetService, IStoreService, IVariableService } from '../../../services';
import { Store } from '../../../stateManagement/Store';
import { StoreElement } from '../../../stateManagement';
import { UploadPanelConfiguration } from '../panels/uploadPanel/uploadPanel.component';

class AdministrationStateController implements angular.IComponentController {
    apiInformation: IApiInformation;
    errorMessage: string;
    hasError: boolean;
    isLoading: boolean;
    loadingMessage: string;
    querySetConfig: UploadPanelConfiguration;
    uploadLicenseFile: FileList;
    variableTypeConfig: UploadPanelConfiguration;

    private _unsubscribe: () => void;

    static $inject = [
        'storeService',
        'licenseService',
        'querySetService',
        'variableService',
        'translatedLoggerService'
    ];

    constructor(
        private _storeService: IStoreService,
        private _licenseService: ILicenseService,
        private _querySetService: IQuerySetService,
        private _variableService: IVariableService,
        private _loggerService: ILoggerService
    ) {
    }

    $onInit() {
        this.isLoading = true;
        this._unsubscribe = this._storeService.register((store: Store) => {
            this.apiInformation = store.apiInformation.value;
            this.isLoading = false;
        }, [StoreElement.ApiInformation]);

        this.variableTypeConfig = {
            buttonTooltip: 'Upload new variable types file',
            controlId: 'variableTypes-file-upload',
            fileExtension: '.zip',
            title: 'Variable types',
            upload: fileList => this.uploadVariableType(fileList)
        };
        this.querySetConfig = {
            buttonTooltip: 'Upload new query set',
            controlId: 'queryset-file-upload',
            fileExtension: '.xml',
            title: 'Query set',
            upload: fileList => this.uploadQuerySet(fileList)
        };
    }

    $onDestroy() {
        this._unsubscribe();
    }

    uploadLicense() {
        if (!!this.uploadLicenseFile && this.uploadLicenseFile.length > 0) {
            this.isLoading = true;
            this._licenseService
                .upload(this.uploadLicenseFile[0])
                .then(data => {
                    this.hasError = !data.result;
                    this.errorMessage = data.message;
                    if (!this.hasError) {
                        this._storeService.dispatchers().apiInformation.getApiInformation();
                    }
                })
                .finally(() => this.isLoading = false);
        }
    }

    uploadQuerySet(uploadQuerySetFile: FileList): angular.IPromise<void> {
        if (!!uploadQuerySetFile && uploadQuerySetFile.length > 0) {
            this.isLoading = true;
            return this._querySetService
                .upload(uploadQuerySetFile[0])
                .then(data => {
                    if (data.result) {
                        this._loggerService.logSuccess('Saved');
                        this.querySetConfig.invalid = undefined;
                    } else {
                        this.querySetConfig.invalid = data.message;
                    }
                })
                .catch(reason => {
                    console.log(reason);
                    this._loggerService.logError('Query set has not been installed, consult logs for details.');
                })
                .finally(() => {
                    this.isLoading = false;
                });
        }
    }

    uploadVariableType(fileList: FileList) {
        if (!!fileList && fileList.length > 0) {
            this.isLoading = true;
            return this._variableService
                .upload(fileList[0])
                .then(data => {
                    if (data.isSuccessful) {
                        this._storeService.dispatchers().variables.updateAll(data);
                        this._loggerService.logSuccess('Variable types successfully updated.');
                    } else {
                        this._loggerService.logError('Failed to update variable types. Check log files for more info.');
                    }
                })
                .catch(e => this._loggerService.logError('Failed to update variable types.'))
                .finally(() => this.isLoading = false);
        }
    }

    generateLicense() {
        this.isLoading = true;
        this._licenseService.generate()
            .catch(reason => {
                console.error(reason);
                this._loggerService.logError('License could not be generated, consult log.');
            })
            .finally(() => {
                this.isLoading = false;
            });
    }
}

export const wtAdministrationState: ComponentDefinition = {
    componentId: 'wtAdministrationState',
    controller: AdministrationStateController,
    template: require('./administrationState.component.html'),
    controllerAs: 'vm',
    bindings: {}
};